<template>
<div>
    <transition name="fade">
        <div v-if="performingRequest" class="loading">
            <p>Submitting your order...</p>
        </div>
    </transition>
    <transition name="fade">
        <div v-if="checkingAddress" class="loading">
            <p>Checking Your Address</p>
        </div>
        </transition>
    <div>
        <!-- Address validation if new address found -->
        <b-modal no-fade size="l" id="modal-newaddresscheck" title="We Found a Matching Address" 
            ok-title="Yes, Update"  @ok="updateAddress()">
                <template v-slot:default="{ hide }">
                    <p>{{validatedAddress.street1}}</p>
                    <p>{{validatedAddress.street2}}</p>
                    <p>{{validatedAddress.zip}}</p>
                </template>
        </b-modal>

        <!-- Invalid address modal -->
        <b-modal no-fade size="l" id="modal-invalidaddress" ok-only title="This Does Not Seem To Be a Valid Address" >
            Please check the address and try again
        </b-modal>

        <!-- Modal for quantity error -->
        <b-modal no-fade  size="l" id="modal-quantityexceedscart" ok-only title="Error" ok-title="OK">
            {{quantityerrormessage}}   
        </b-modal>

        <!-- Modal to enter a new address -->
        <b-modal no-fade  size="l" id="modal-newaddress" title="Enter a new address" @ok="checkAddress()" ok-title="Update">
            Enter New Address
            <b-input-group prepend="Street1" class="mt-3">
                <b-form-input v-model="newAddress.street1" ></b-form-input>
                <b-input-group-append>
                </b-input-group-append>
            </b-input-group>
            <b-input-group prepend="Street2" class="mt-3">
                <b-form-input v-model="newAddress.street2" ></b-form-input>
                <b-input-group-append>
                </b-input-group-append>
            </b-input-group>
            <b-input-group prepend="City" class="mt-3">
                <b-form-input v-model="newAddress.city" ></b-form-input>
                <b-input-group-append>
                </b-input-group-append>
            </b-input-group>
            <b-input-group prepend="State" class="mt-3">
                <b-form-input v-model="newAddress.state" ></b-form-input>
                <b-input-group-append>
                </b-input-group-append>
            </b-input-group>
            <b-input-group prepend="zip" class="mt-3">
                <b-form-input v-model="newAddress.zip" ></b-form-input>
                <b-input-group-append>
                </b-input-group-append>
            </b-input-group>
        </b-modal>
    </div>
        
    <b-container>
        <!-- Order placed message -->
        <b-row>
            <b-col v-if = showOrdersPlaced>
                <h4> Your order has been placed. We will update you when the brewery accepts your order </h4>
            </b-col>
        </b-row>

         <b-row style="margin-top:20px" v-if ="getCartSize">
            <h4 style="margin-left:20px">Your Shopping Cart</h4>
        </b-row>
        <hr>

        <!-- Cart is empty message -->
        <b-row>
        <div class="col1" v-if ="!getCartSize">
            <br>
            <h5>Nothing in your cart yet. Go to <router-link to="allbeers" >FIND BEERS</router-link> to add some beers to your cart</h5>

        </div>
        </b-row>

        <!-------------------------->
        <!-- Iterate over brewers -->
        <!-------------------------->
        <template v-for="brewer in consumerCart">
            <b-card :key="brewer.brewerid" v-if="brewer.cartItems.length>0" style="margin-bottom:10px; background-color:#f2f2f2">
                
                <h4 v-if="brewer.cartItems.length>0">{{brewer.brewer}}</h4>
                <!-- Iterate over items in cart -->
                <div v-if="brewer.cartItems.length>0">
                    <table class="table">
                        <tbody>
                            <tr v-for="item in brewer.cartItems" :key="item.suborderid">
                                <b-container>
                                    <b-row>
                                        <!-- Image -->
                                        <b-col>
                                            <div v-if="getImageSource(item)" style="75px">
                                                <img :src="getImageSource(item)" width="75px" fluid alt="Logo image">
                                            </div>
                                            <div v-else style="height:75px; text-align: center">
                                                <img src="https://res.cloudinary.com/lo4xxr5lr/image/upload/v1574513408/stock/beer.jpg" width="100%" fluid alt="Logo image">
                                            </div>
                                        </b-col>
                                        <b-col>
                                            <b-container>
                                                <!-- Beverage and size -->
                                                <b-row class="beernamecart"><b-col>{{item.beerName}}, {{item.size}} </b-col></b-row>
                                                <!-- Quantity updates for large devices -->
                                                <b-row style="margin-top:20px"  v-if="getWindowWidth>=800">
                                                    <!-- Quantity button -->
                                                    <b-col >
                                                        <b-button-group  style="border-width:1px; border-color:#bfbfbf; border-style:solid; border-radius:5px">
                                                            <b-button  variant="transparent"><font-awesome-icon icon="minus"  @click="updateConsumerQuantity(item.id, item.orderQuantity-1, item)"/></b-button>
                                                            <div style="width:50px; text-align:center; border-width:2px; border-color:#000; margin-top:5px"> {{item.orderQuantity}}</div>
                                                            <b-button variant="transparent"><font-awesome-icon icon="plus"  @click="updateConsumerQuantity(item.id, item.orderQuantity+1, item)"/></b-button>
                                                            <!-- Delete button -->
                                                            <b-button size="sm" variant="outline-danger" style="margin-left:20px" v-b-modal="'delete' + item.suborderid">Delete</b-button>
                                                        </b-button-group>
                                                    </b-col>
                                                </b-row> 
                                                
                                            </b-container>
                                        </b-col>
                                    </b-row>
                                    <!-- Quantity updates for small devices -->
                                    <b-row style="margin-top:20px"  v-if="getWindowWidth<800">
                                        <b-col>
                                            <b-button-group  style="border-width:1px; border-color:#bfbfbf; border-style:solid; border-radius:5px">
                                                <b-button  variant="transparent"><font-awesome-icon icon="minus"  @click="updateConsumerQuantity(item.id, item.orderQuantity-1, item)"/></b-button>
                                                <div style="width:50px; text-align:center; border-width:2px; border-color:#000; margin-top:5px"> {{item.orderQuantity}}</div>
                                                <b-button variant="transparent"><font-awesome-icon icon="plus"  @click="updateConsumerQuantity(item.id, item.orderQuantity+1, item)"/></b-button>
                                                <!-- Delete button -->
                                                <b-button size="sm" variant="outline-danger" style="margin-left:20px" v-b-modal="'delete' + item.suborderid">Delete</b-button>
                                            </b-button-group>
                                        </b-col>
                                    </b-row>

                                    <!-- Sub item cost -->
                                    <b-row>
                                        <b-col>
                                            Cost: ${{item.itemsCost}}
                                        </b-col>
                                    </b-row>
                                </b-container>
                                <!-- Delete modal -->
                                <b-modal size="sm" style="width:100%" :id="'delete' + item.suborderid" title="Delete"  ok-title="Delete" cancel-title='No, do not delete' @ok="deleteFromConsumerCart(item.suborderid)">
                                    <p class="my-4">Delete {{item.beerName}} from cart?</p>
                                </b-modal>
                                <hr>
                            </tr>
                        </tbody>
                    </table>
                    <!-- End of iterate over items for one brewer -->

                    <!-- Error message if number of bottles or cans is less than 24 -->
                    <b-row class="errorclass" v-if="!brewer.minCanCountOK">
                        <b-col>
                            Must order at least 24 bottles and/or cans from each brewery
                        </b-col>
                    </b-row>

                    <!------------------------------------------>
                    <!-- Select shipping or delivery option -->
                    <!------------------------------------------>
                    <b-button-group style="text-align:right">
                        <button type="button" class="btn btn-light" v-for="option in brewer.availableDeliveryOptions" :key="option + brewer.mainorderid"> 
                            {{option}}
                            <div v-if="brewer.selectedDeliveryOption==option" class="filledcircle" @click="updateDeliveryOption(brewer.brewerid, option)"></div>
                            <div v-else class="emptycircle" @click="updateDeliveryOption(brewer.brewerid, option)"></div>
                        </button>
                    </b-button-group>

                    <!-- No delivery selected error -->
                    <b-row v-if ="!brewer.selectedDeliveryOption" style="margin-top:10px; color:red">
                        <b-col>
                            Please select a delivery option
                        </b-col>
                    </b-row>

                    <!-- Items cost for this brewer -->
                    <b-row v-if="brewer.cartItems.length>0" style="text-align:right">
                        <b-col>
                            Total Items Cost: ${{brewer.totalItemsCost}}
                        </b-col>
                    </b-row>

                    <!-- Shipping for this brewer-->
                    <div v-if="brewer.selectedDeliveryOption=='Ship'">
                        <!-- Min for free shipping -->
                        <b-row v-if ="brewer.cartItems.length>0&&brewer.minForFreeShipping>0&&brewer.shippingCost>0" style="text-align:right">
                            <b-col cols='12'>
                                <i> Order ${{brewer.minForFreeShipping}} of shipped items to get free shipping</i>
                            </b-col>
                        </b-row>
                        <b-row v-if="brewer.cartItems.length>0" style="text-align:right">
                            <b-col>
                                Shipping Cost: ${{brewer.shippingCost}}
                            </b-col>
                        </b-row>
                    </div>

                    <!-- Delivery cost for this brewer -->
                        <div v-if="brewer.selectedDeliveryOption=='Deliver'">
                        <b-row v-if ="brewer.cartItems.length>0&&brewer.minForFreeDelivery>0&&brewer.deliveryCost>0" style="text-align:right">
                            <b-col cols='12'>
                                <i> Order ${{brewer.minForFreeDelivery}} of delivered items to get free delivery</i>
                            </b-col>
                        </b-row>
                        <b-row v-if="brewer.cartItems.length>0" style="text-align:right">
                            <b-col>
                                Delivery Cost: ${{brewer.deliveryCost}}
                            </b-col>
                        </b-row>

                        <!-- Keg deposit -->
                        <b-row v-if="brewer.kegDeposit>0" style="text-align:right">
                            <b-col>
                                Refundable Keg Deposit: ${{brewer.kegDeposit}}
                            </b-col>
                        </b-row>
                    </div>
                </div>
                <!-- End of div v-if=cart-items length > 0 -->
            </b-card>
        </template>
        <!-------------------------->
        <!-- End of brewer loop -->
        <!-------------------------->

        <hr>
       <!-------------------------->
        <!-- User address -->
        <!-------------------------->
        <b-row>
            <b-col>
                <h5> Shipping and Billing Address</h5>
            </b-col>
        </b-row>

        <!-- Default address -->
        <b-row>
            <b-card :bg-variant="defaultAddressVariant.background" style="cursor:pointer; margin-top:10px; margin-left:10px;" @click="chooseAnotherAddress(userProfile.street1, userProfile.street2,userProfile.city, userProfile.state,  userProfile.zip, 0, 1)">
                <div :style="defaultAddressVariant.textStyle">{{userProfile.street1}}</div>
                <div v-if="userProfile.street2" :style="defaultAddressVariant.textStyle">{{userProfile.street2}}</div>
                <div :style="defaultAddressVariant.textStyle">{{userProfile.city}}, {{userProfile.state}} {{userProfile.zip}}</div>
                <!-- Edit address -->
                <b-button variant="warning" style="margin:10px" v-b-modal.modal-newaddress >Edit address</b-button>
                <div  style="margin:10px; color:white">We can only ship and deliver to billing address</div>
            </b-card>
            
        </b-row>
        
        <!-------------------------->
        <!-- Complete Cart Items cost -->
        <!-------------------------->
        <b-row v-if ="getCartSize" class="coststyle">
            <b-col cols='12'>
                <hr>
                <h6> Items Cost:<span> ${{getItemsCost}}</span></h6>
            </b-col>
        </b-row>

        <!-- Total taxes -->
        <b-row v-if ="getCartSize" class="coststyle">
            <b-col cols='12'>
                <h6> Taxes:<span> ${{getSalesTax}}</span></h6>
            </b-col>
        </b-row>

         <!-- Shipping Fees -->
        <b-row v-if ="getCartSize&&getShippingFees>0" class="coststyle">
            <b-col cols='12'>
                <h6> Shipping:<span > ${{getShippingFees}}</span></h6>
            </b-col>
        </b-row>

        <!-- Delivery Fees -->
        <b-row v-if ="getCartSize&&getDeliveryFees>0" class="coststyle">
            <b-col cols='12'>
                <h6> Delivery:<span > ${{getDeliveryFees}}</span></h6>
            </b-col>
        </b-row>

        <!-- Keg Deposit -->
        <b-row v-if ="getKegDeposit>0" class="coststyle">
            <b-col cols='12'>
                <h6> Refundable Keg Deposit:<span > ${{getKegDeposit}}</span></h6>
            </b-col>
        </b-row>

        <!-- Kegseeker Fees -->
        <b-row v-if ="getCartSize" class="coststyle">
            <b-col cols='12'>
                <h6> Keg Seeker Fees:<span> ${{kegseekerFees}}</span></h6>
            </b-col>
        </b-row>

        <!-- Total Cost -->
        <b-row v-if ="getCartSize" class="coststyle">
            <b-col cols='12'>
                <h4> Total Cost:<span style="color:green"> ${{costWithTax}}</span></h4>
            </b-col>
        </b-row>

        <hr>

        <b-row v-if ="getCartSize">
            <b-col>
                <div style="color:green">
                    Notes (optional): <small>Add a note to sellers</small>
                </div>
                <b-form-textarea id="textarea-formatter" v-model="buyerNote" placeholder="Note to sellers"></b-form-textarea>
            </b-col>
        </b-row>

        <!-- Go To Checkout -->
        <!-- Min can size error -->
        <b-row v-if ="getCartSize&&!minCanOrderSizeMet" style="margin-top:10px; color:red">
            <b-col>
                Please order at least 24 cans or bottles from each brewery
            </b-col>
        </b-row>

        <!-- No delivery selected error -->
        <b-row v-if ="!checkDeliverySelected" style="margin-top:10px; color:red">
            <b-col>
                Please select a delivery option for all your orders
            </b-col>
        </b-row>

        <b-row v-if ="getCartSize" style="margin-top:10px">
            <b-col>
                <b-button :disabled="!minCanOrderSizeMet||!checkDeliverySelected" size="lg" block v-b-modal.modal-submit1 variant='success' @click="gotToCheckout()">CHECKOUT</b-button>
            </b-col>
        </b-row>

        <!-- Continue shopping button -->
        <b-row style="margin-top:10px">
            <b-col>
                <b-button variant='success' @click="continueShopping">CONTINUE SHOPPING</b-button>
            </b-col>
        </b-row>


        
    </b-container>
    <footer><pagefooter/></footer>
    </div>
</template>

<script>

    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../../firebaseConfig.js')
    import firebase from 'firebase/app';
    import {incrementbeerinventory} from '../Myfunctions'
    import { checkAddress } from '../Myfunctions'
    const db = firebase.firestore()
    import axios from 'axios'
    import Pagefooter from '../Pagefooter'
    import {sendnotification} from '../Myfunctions'

    export default {
        components: {
            Pagefooter,
        },

        data() {
            return {
                beer:'',
                totalCartCost:0,
                orderedNumber:0,
                performingRequest:false,
                inventoryChanged:false,
                showOrdersPlaced:false,
                quantityerrormessage:'',
                buyerNote:'',
                desiredDate:'',
                licenseNumberValid:false,
                shippingAddress:{},
                defaultAddressSelected: true,
                selectedAddress:'',
                selectedAddressIndexVariant:[],
                invalidDeliveryOption:false,
                newAddress:{
                    street1:'',
                    street2:'',
                    city:'',
                    zip:'',
                    state:'',
                },
                costWithTax:0,
                //Delivery or pickup
                deliverOrder:'1',
                kegseekerFees:2.99,
                finalOrdersArray:[],
                brewerShippingCosts:[],
                checkingAddress:false,
                validatedAddress:{},
                street1:'',
                street2:'',
                state:'',
                zip:'',
                selectedDeliveryOption:'',
                kegDeposit:0,
                }
        },

        computed: {
            ...mapState(['userProfile', 'currentUser', 'consumerCart', 'everyAvailableBeer']),

            //Window size
            getWindowWidth(){
                return window.innerWidth;
            },

            //Check if min order size for each brewery is met
            minCanOrderSizeMet(){
                var orderSizeMet=true
                for (var i=0; i<this.consumerCart.length; i++) if (this.consumerCart[i].minCanCountOK==0) orderSizeMet=false
                return orderSizeMet
            },

            //Compute total cart cost
            getItemsCost: function () {
                var totalCost = 0

                //Iterate over all brewers
                for (var i=0; i<this.consumerCart.length; i++)
                    totalCost = totalCost + this.consumerCart[i].totalItemsCost
                this.totalCartCost = totalCost
                return this.totalCartCost
            },

            //Compute sales tax
            getSalesTax(){
                var tax = parseFloat(this.userProfile.salestax)
                tax = tax * this.totalCartCost
                var newtax = tax
                this.costWithTax = parseFloat((this.totalCartCost + tax + this.getShippingFees + this.getDeliveryFees  + this.kegseekerFees+ this.getKegDeposit))
                this.$store.commit("setCartCost", this.costWithTax )
                return newtax
                
            },

            //Shipping fees
            getShippingFees(){
                var shippingCost = 0
                //Iterate over all brewers
                for (var i=0; i<this.consumerCart.length; i++)
                    if(this.consumerCart[i].selectedDeliveryOption=="Ship") shippingCost = shippingCost + this.consumerCart[i].shippingCost
                return shippingCost
            },

            //Delivery fees
            getDeliveryFees(){
                var deliveryCost = 0
                //Iterate over all brewers
                for (var i=0; i<this.consumerCart.length; i++)
                    if(this.consumerCart[i].selectedDeliveryOption=="Deliver") deliveryCost = deliveryCost + this.consumerCart[i].deliveryCost
                return deliveryCost

            },

            //Get keg depost
            getKegDeposit(){
                var kegDeposit=0
                for (var i=0; i<this.consumerCart.length; i++){
                    if(parseFloat(this.consumerCart[i].kegDeposit)>0) kegDeposit = kegDeposit + parseFloat(this.consumerCart[i].kegDeposit)
                }
                return kegDeposit

            },

            //Check that delivery option is selected for all orders
            checkDeliverySelected(){
                var validDel = true
                for (var i=0; i<this.consumerCart.length; i++){
                    console.log("this.consumerCart.selectedDeliveryOption = " + this.consumerCart[i].selectedDeliveryOption)
                    if(!this.consumerCart[i].selectedDeliveryOption) validDel = false
                }
                return validDel
            },

            getCartSize(){
                return this.consumerCart.length
            },
            defaultAddressVariant(){
                var defaultVariant={}
                defaultVariant.background="light"
                defaultVariant.textStyle={color:"black"}
                if(this.defaultAddressSelected){
                    defaultVariant.background="info"
                    defaultVariant.textStyle={color:"white"}
                } 
                return defaultVariant
            },
        },

        methods: {

            //Cart item image source
            getImageSource(beer){
                //return {"uri": this.navigation.getParam("beer").logoFileThumbnailURL}

                if(beer.beerLogoURL) return beer.beerLogoURL
                else if (beer.logoFileThumbnailURL) return  beer.logoFileThumbnailURL
                else return require('../../assets/beer.jpg')
            },

            //Delete
            deleteItem(suborderid) {
                this.$store.commit('deleteItemFromCart', suborderid)
            },

            //Update cosumer cart quantity
            updateConsumerQuantity(beerId,quantity, beerObject) {
                //Check 0 qty
                if (quantity<=0) return

                var theCart = this.consumerCart
                //Iterate over brewers to find this item
                for (var j=0; j<theCart.length; j++){
                    var thisBrewerObject = theCart[j]
                    var thisBrewerItems = thisBrewerObject.cartItems
                    var thissuborderindex = thisBrewerItems.findIndex(item => item.suborderid === beerObject.suborderid);
                    //When suborder found, update quantity
                    if(thissuborderindex>-1){
                        var toupdate = thisBrewerItems[thissuborderindex]
                        toupdate.orderQuantity=quantity
                        toupdate.itemsCost = toupdate.orderQuantity * toupdate.costPerItem
                        thisBrewerItems.splice(thissuborderindex, 1, toupdate);
                        thisBrewerObject.cartItems=thisBrewerItems
                        theCart.splice(j, 1, thisBrewerObject);
                        this.$store.commit('setConsumerCart', theCart)
                        
                    }
                }
            },

            //Update delivery option
            updateDeliveryOption(brewerid, option){
                console.log("Updating delivery option for ")
                console.log(brewerid)
                var theCart = this.consumerCart
                //Iterate over brewers to find this item
                for (var j=0; j<theCart.length; j++){
                    var thisBrewerObject = theCart[j]
                    if (thisBrewerObject.brewerid==brewerid){
                        thisBrewerObject.selectedDeliveryOption = option
                        theCart.splice(j, 1, thisBrewerObject);
                    }
                }
                this.$store.commit('setConsumerCart', theCart)
            },

            //Delete item from consumer cart
            deleteFromConsumerCart(suborderid){
                var theCart = this.consumerCart
                //Iterate over brewers to find this item
                for (var j=0; j<theCart.length; j++){
                    var thisBrewerObject = theCart[j]
                    var thisBrewerItems = thisBrewerObject.cartItems
                    var thissuborderindex = thisBrewerItems.findIndex(item => item.suborderid === suborderid);
                    //When suborder found, update quantity
                    if(thissuborderindex>-1){
                        thisBrewerItems.splice(thissuborderindex, 1);
                        thisBrewerObject.cartItems=thisBrewerItems
                        theCart.splice(j, 1, thisBrewerObject);
                        this.$store.commit('setConsumerCart', theCart)
                    }
                }

            },

            //Check new address

            checkAddress(){
                //Check if address is valid
                if(!this.street2) this.street2 =''
                this.checkingAddress = true
                
                //Function to capitalize first letter of each word
                function titleCase(str) {
                    var splitStr = str.toLowerCase().split(' ');
                    for (var i = 0; i < splitStr.length; i++) {
                        // You do not need to check if i is larger than splitStr length, as your for does that for you
                        // Assign it back to the array
                        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1).toLowerCase();     
                    }
                    // Directly return the joined string
                    return splitStr.join(' '); 
                    }

                var correctedAddress = checkAddress(this.newAddress.street1, this.newAddress.street2, this.newAddress.city, this.newAddress.zip, this.newAddress.state).then(response => {
                        console.log("In response")
                        this.checkingAddress = false
                        if (response=='ERROR'){
                            console.log("ERROR")
                            this.$bvModal.show("modal-invalidaddress")
                        } 
                        else {
                            console.log(response.data)
                            var newAddressChecked = response.data
                            if(newAddressChecked.status=="INVALID"){
                                this.$bvModal.show("modal-invalidaddress")
                                return
                            }

                            //New address found
                            else if (newAddressChecked.status=="SUSPECT"){
                                this.validatedAddress.company = this.userProfile.company
                                this.validatedAddress.street1 = newAddressChecked.addressline1
                                if(this.validatedAddress.street2)
                                    this.validatedAddress.street2 = newAddressChecked.addressline2
                                else
                                    this.validatedAddress.street2 = ""
                                this.validatedAddress.state= newAddressChecked.state
                                this.validatedAddress.city = newAddressChecked.city
                                this.validatedAddress.country = newAddressChecked.country
                                this.validatedAddress.zip = newAddressChecked.postalcode.substr(0, 5);
                                this.validatedAddress.county = titleCase(newAddressChecked.county)
                                console.log("Updating address = ")
                                console.log(this.validatedAddress)
                                this.$bvModal.show("modal-newaddresscheck")

                            }

                            //User entered a good address
                            else{
                                this.validatedAddress.company = this.userProfile.company
                                this.validatedAddress.street1 = this.newAddress.addressline1
                                if(this.validatedAddress.street2)
                                    this.validatedAddress.street2 = this.newAddress.addressline2
                                else
                                    this.validatedAddress.street2 = ""
                                
                                this.validatedAddress.state= this.newAddress.state
                                this.validatedAddress.city = this.newAddress.city
                                this.validatedAddress.country = this.newAddress.country
                                this.validatedAddress.zip = this.newAddress.postalcode.substr(0, 5)
                                this.validatedAddress.county = titleCase(this.newAddress.county)
                                this.updateAddress()

                            }
                        }
                 })

            },
            
            //Update user address
            updateAddress(){
                this.showSuccess = true
                    
                setTimeout(() => { this.showSuccess = false }, 1500)
                    fb.usersCollection.doc(this.currentUser.uid).update({
                            street1:this.validatedAddress.street1,
                            street2:this.validatedAddress.street2,
                            zip:this.validatedAddress.zip,
                            county: this.validatedAddress.county,
                            state:this.validatedAddress.state,
                            country:this.validatedAddress.country,
                            city:this.validatedAddress.city
                        })
                        /*
                        if((this.validatedAddress.zip!=this.userProfile.zip)&&(this.userProfile.isbrewer==1||this.userProfile.isbrewer==2))
                            //Update delivery radius
                            this.$store.dispatch('updateDeliveryZipCodesWithNewZipAsync', this.validatedAddress.zip )
                            */
                            
                        this.$store.dispatch('fetchUserProfile')
            },


            //Select a different address
            chooseAnotherAddress(street1, street2, city, state, zip, index, defaultSelected){
                if(defaultSelected){
                    this.defaultAddressSelected = true
                } 
                else this.defaultAddressSelected = false
                
                //Setup fonts and background color
                this.selectedAddressIndexVariant = []

                for (var i=0; i<this.userProfile.otherAddresses.length; i++){
                    var thisVariant={}
                    thisVariant.background="light"
                    thisVariant.textStyle={color:"black"}
                    this.selectedAddressIndexVariant[i] = thisVariant

                    if (i==index&&!defaultSelected){
                        thisVariant.background="info"
                        thisVariant.textStyle={color:"white"}
                        this.selectedAddressIndexVariant[i] = thisVariant

                    }
                }

                console.log(street1, street2,city, state, zip )
                
                this.selectedAddress = street1
                if(street2) this.selectedAddress = this.selectedAddress  + ' ' +street2
                this.selectedAddress = this.selectedAddress  + ', '  + city + ', ' + state + ' ' + zip

            },

            //Consumers, go to checkout
            gotToCheckout(){
                //this.$store.commit('setCheckoutCart', this.consumerCart)
                this.$router.push({ name: 'checkout'})
            },
            continueShopping(){
                this.$router.push({ name: 'allbeers'})

            },

            //Quantity changed
            quantityChanged(item){
                console.log("Qty changed")
                console.log(item)
            },
        },
        
    }
</script>
<style scoped>
.active {
  background: green;
}
.inactive {
  background: whitesmoke;
}

.coststyle{
    text-align:right;
    padding-right:50px;
}

.cardclass{
    background-color:#f2f2f2;
    margin-top:10px;
}

.brewerynamecart{
    font-size:15px;
}
.beernamecart{
    font-size:20px;
    font-weight:bold;
}

.emptycircle{
    border-radius: 15px/15px;
    border: solid 2px black;
    width: 15px;
    height: 15px;
}

.filledcircle{
    border-radius: 10px/10px;
    border: solid 10px #0275d8;
    width: 10px;
    height: 10px;
}

.errorclass{
    color:red;
}

</style>